<template>
  <div v-bind="$attrs">
    <div
      :class="['section-header', { 'section-header--two-columns': hasTwoColumnsHeader}]"
      v-if="$slots.control || title"
    >
      <Heading
        :icon="icon"
        :image="image"
        :style="`minWidth: ${headingWidth}`"
        class="heading"
        kind="h2"
        type="h2"
        v-if="title"
      >
        {{ title }}
        <span
          class="heading-description"
          v-if="description"
        >{{ description }}</span>
      </Heading>
      <template
        v-if="$slots.control"
      >
        <div class="section-header__control">
          <slot
            name="control"
          />
        </div>
      </template>
    </div>
    <div :class="{'col-layout-two': twoColLayout, [customClass]: customClass}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customClass: String,
    description: String,
    icon: String,
    image: String,
    hasTwoColumnsHeader: {
      type: Boolean,
      default: false,
    },
    headingWidth: String,
    title: {
      type: String,
      required: false,
    },
    twoColLayout: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
  .section-header {
    display: flex;
    align-items: center;

    @media only screen and (width <= 600px) {
      flex-direction: column;
      align-items: flex-start;
    }

    &__control {
      margin-left: auto;
      width: 33%;
      text-align: right;

      @media only screen and (width <= 600px) {
        width: 100%;
      }
    }

    .new-form-enabled & {
      margin-bottom: rem(40px);

      h2 {
        font-weight: 600;
        margin-bottom: 0;
        margin-top: 0;
      }

      @include media('<sm') {
        margin-top: rem(20px);
        margin-bottom: rem(20px);

        h2 {
          padding-left: rem(35px);
        }
      }
    }
  }

  .section-header--two-columns {
    align-items: flex-start;
    gap: 24px;

    .heading {
      flex-shrink: 0;
    }

    .section-header__control {
      border-left: 1px solid $--border-color-base;
      flex: 1 1 100%;
      padding-left: 24px;
      text-align: left;
      width: auto;
    }

    @media only screen and (max-width: $--sm - 1px) {
      flex-wrap: wrap;

      .section-header__control {
        border-left: unset;
        margin-left: 0;
        padding-left: 0;
        width: 100%;
      }
    }
  }

  .col-layout-two {
    @include media('>md') {
      display: grid;
      grid-template-rows: repeat(5, auto);
      grid-template-columns: repeat(2, 1fr);
      grid-auto-flow: column;
      gap: 0 68px;

      .sk & {
        grid-template-rows: repeat(6, auto);
      }
    }
  }

  .heading-description {
    color: $--color-text-blue;
    display: block;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    padding-top: 3px;
  }

  .el-form-item--lg {
    :deep() {
      .el-form-item {
        margin-bottom: 2.678rem;
      }
    }
  }
</style>
